export const STRIPE_PROCESSOR_CONNECTION_SFID = "a0P37000009suBVEAY";

export const RECORDTYPE_PERSON_CONTACT = "01237000000TgqkAAC";
